/* eslint-disable no-unused-vars,max-len */
/* global PLATFORM, G */
import { asyncPipeSpread, def, isNum, isStr } from 'lib/util'
import sequenceComponentFind from 'lib/sequence/component/children/find'
import session from 'app/_shared/session'
import { get } from 'lib/sequence/component/state/value'
import { show } from 'lib/sequence/component/state/hidden'
import { disable, enable } from 'lib/sequence/component/state/disabled'

/**
 * Determines whether the `salesOrganisationSection` should be shown.
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, *, ...[*]): Promise<*|Promise<Awaited<*>>>}
 */
const displaySalesOrganisations = module => async (children, ...args) => {
  const { user } = session(module)

  const userDoc = user?.ref()
  const salesOrganisations = userDoc?.value?.custom?.user?.combinations || []

  const { component, salesOrganisation } = children
  const { btnOk } = sequenceComponentFind(component[G.ACTIONS][0])

  if (salesOrganisations.length > 0) {
    show(btnOk)
    show(salesOrganisation)
    !get(salesOrganisation) && disable(btnOk)
  }

  const salesOrganisationValue = get(salesOrganisation)

  def(salesOrganisationValue)
    && (isStr(salesOrganisationValue) || isNum(salesOrganisationValue))
    && enable(btnOk)

  return [children, ...args]
}

/**
 * Cart CSV Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displaySalesOrganisations(module),
)(sequenceComponentFind(component), ...args)
